<template>
  <!-- 黑名单管理 -->
  <div>
    <div v-show="Hmdgl">
      <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">黑名单管理</div>
      <!-- 主体 -->
      <div style="height:750px;background-color:white;margin:75px 40px 0 40px">
        <!-- 查询框 -->
        <div style="margin-left:3%">
          <div style="height:10px"></div>
					
					
          <div style="display:inline-block;margin-top:20px">
            <span>组织架构 </span>
             <el-cascader v-model="condition.organize_ids" clearable
                 style="margin-left:10px;width:220px" collapse-tags :props="props"></el-cascader>
          </div>

        <div style="display:inline-block;margin-left:10px">
            <span>城市 </span>
            <el-select v-model="condition.city_id" style="margin-left:10px;width:130px"
                :placeholder="postPlaceholder" clearable>
                <el-option v-for="item in $globals.cityList"  :key="item.city" :label="item.city" :value="item.city">
                </el-option>
            </el-select>
        </div>

        <div style="display:inline-block;margin-left:10px">
            <span>离职日期 </span>
            <el-date-picker style="width:130px;margin-left:10px" v-model="condition.start_date" type="datetime"
              placeholder="请选择" value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>

          <div style="display:inline-block;margin-left:10px">
            <span>离职原因 </span>
            <el-select v-model="condition.is_signContract" style="margin-left:10px;width:130px" placeholder="请选择" clearable>
          <el-option
            v-for="item in causeList"
            :key="item.id"
            :label="item.data"
            :value="item.id">
          </el-option>
        </el-select>
        </div>

        <div style="display:inline-block;margin-left:10px">
            <span>姓名 </span>
          <el-input v-model="condition.staff_name" style="margin-left:10px;width:130px" 
                    placeholder="请输入姓名"></el-input>
        </div>

          

          <!-- 按钮 -->
          <div style="display:inline-block;margin:20px 50px;float:right">
            <el-button type="goon" @click="Find">查询</el-button>
            <el-button type="goon" @click="yichu(null)">移除</el-button>

            <div style="display:inline-block;margin-left:220px">
              <download-excel class="export-excel-wrapper" :fields="download_excel" title="黑名单"
                    name="黑名单.xls" :fetch="ExportForm"
                    style="margin-left:-180px;top:100px">
                <el-button type="goon" style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
                  导表</el-button>
              </download-excel>
            </div>

          </div>
          
          

        </div>

        <!-- 表格 -->
        <div style="margin:2% 3% 0 3%">
          <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}" :row-class-name="tableRowClassName"
            ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;" height="540"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column align="center" label="序号" width="50">
              <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
            </el-table-column>
            <el-table-column align="center" label="组织架构" width="300">
              <template slot-scope="scope">
                {{$globals.group_name + "/" + scope.row.staff.range}}
              </template>
            </el-table-column>
            <el-table-column prop="staff.city_id" align="center" label="城市"></el-table-column>
            <el-table-column prop="staff.post_name" align="center" label="职位"></el-table-column>
            <el-table-column prop="staff.staff_name" align="center" label="姓名"></el-table-column>
            <el-table-column prop="staff.staff_card" align="center" label="身份证号码" width="200"></el-table-column>
            <el-table-column prop="staff.staff_telephone" align="center" label="手机号" width="110"></el-table-column>
            <el-table-column prop="dictionaries_time" align="center" label="离职日期"></el-table-column>
            <el-table-column prop="dictionaries_data" align="center" label="离职原因" width="150"></el-table-column>
            <el-table-column prop="settlement_effective" align="center" label="状态" ></el-table-column>
            <el-table-column align="center" label="操作" width="100">
              <template slot-scope="scope">
                <img src="../../../assets/移除.png"   @click="yichu(scope.row)">
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <el-row style="margin-top: 10px; text-align: center;">
            <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
              layout=" prev, pager, next, jumper" :total="total">
            </el-pagination>
          </el-row>
        </div>

      </div>
    </div>
    
    <!-- 移除 -->
    <el-dialog
      title="移除"
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :center="true"
      :before-close="handleClose">
      <yichu ref="yichus" v-show="showyi"></yichu> 
    </el-dialog>
  </div>
</template>

<script>
import yichu from './Hmdgl_yichu.vue';
import axios from 'axios';
export default {
  components: {
    yichu: yichu,
  },
  data() {
		var organizeFind = async (e, spare8) => {
			var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
				identification: "1",
				organize_id: e,
				spare8: spare8,
			});
			return organizeList.data;
		};
    return {
      page_num: 1,
      page_size: 10,
      total: 0,
      tableData: [],
      staffList: [],
      dialogVisible: false,
      ruleForm: {
        id:'',
        effective:'',
        dictionaries_time:'',
        dictionaries_data:'',
        dictionaries_remarks:'',
        remove_date:this.getNowTime(),
        operator:'',
        remove_reason:'',
        ids:[],
        staff:{
          company_name:'',
          modular_name:'',
          city_id:'',
          project_name:'',
          post_name:'',
          staff_name:'',
          staff_card:'',
          staff_telephone:'',
        }
      },

      download_excel: {
				    "组织架构": "staff.range",
				    "姓名": "staff.staff_name",
					  "城市":"staff.city_id",
				    "职位": "staff.post_name",
				    "身份证号": {
              field: "staff.staff_card",
              callback: value => {
                return "&nbsp;" + value;
              }
            },
				    "手机号": "staff.staff_telephone",
				    "离职日期": "dictionaries_time",
            "离职原因": "dictionaries_data",
            "状态":"settlement_effective"
				},

      // 权限
      Hmdgl: true,
      showyi: false,
      ids: [],
      //离职原因
      causeList: [],
      //条件
      condition: {
        organize_ids: [],
        effective:'',
        city_id:'',
        post_name:'',
        staff_name:'',
        staff_card:'',
        start_date:'',
        staff_telephone:'',
        dictionaries_id:'',
      },
      ztList:[{
          value: '0',
          label: '未移除'
        }, {
          value: '1',
          label: '已移除'
      }],
	  
	  //组织架构数据
	  organizeList: [],
	  
	  //级联下拉配置
	  props: {
			lazy: true,
			async lazyLoad(node, resolve) {
				if (node.level === 0) {
					return resolve(await organizeFind('', 'group'));
				} else {
					resolve(await organizeFind(node.data.id, ''));
				}
			},
	      value: "id",
	      label: "organize_name",
	      children: "organizeList",
	      checkStrictly: true,
	      multiple: true,
	  },
	  
    };
  },
  methods: {
    // 全选
    handleSelectionChange(e) {
        this.ids = [];
        e.forEach(item => {
        this.ids.push(item.id);
      });
    },
    // 弹窗
    handleClose() {
        this.dialogVisible = false
    },
    //处理默认选中当前日期
	    getNowTime() {
	       var now = new Date();
	       var year = now.getFullYear(); //得到年份
	       var month = now.getMonth(); //得到月份
	       var date = now.getDate(); //得到日期
	       month = month + 1;
	       month = month.toString().padStart(2, "0");
	       date = date.toString().padStart(2, "0");
	       var defaultDate = `${year}-${month}-${date}`;
	       return defaultDate;
      },
    // 移除
    yichu(e){
      if(e == null){
        if(this.ids.length <= 0){
          this.$message.warning('请选择操作数据！');
        }else{
          this.showyi = true;
          this.dialogVisible =  true;
          this.ruleForm.ids = this.ids;
        }
      }else{
        this.showyi = true;
        this.dialogVisible =  true;
        this.ruleForm.ids =[e.id];
      }
    },
    //查询
    async Find() {
		var temporary = [];
		this.condition.organize_ids.forEach(item => {
		    temporary.push(item[item.length - 1]);
		})
		var organize_ids = "";
		temporary.forEach(item => {
		    organize_ids += item + ",";
		})
		
      var url = 'StaffBlacklist/selectAll';
      var record = {
        page_num: this.page_num,
        page_size: this.page_size,
        data_grouping: 'Hmdgl',
        organize_ids: organize_ids,
        city_id: this.condition.city_id,
        dictionaries_time: this.condition.start_date,
        staff_name: this.condition.staff_name,
        dictionaries_id: this.condition.dictionaries_id,
      };
      var data = await this.$globals.AxiosPost(url, record);
      if (data === '-2000') {
        this.$message.error('服务器未响应！请稍后重试');
      } else {
        var code = data.code;
        var data = data.data;
        if (code === '200') {
          this.tableData = data.list;
          this.total = data.total;
        } else {
          this.$message.warning('请求失败！请稍后重试');
        }
      }
    },

    // 导表
			async ExportForm(){
				var temporary = [];
        this.condition.organize_ids.forEach(item => {
            temporary.push(item[item.length - 1]);
        })
        var organize_ids = "";
        temporary.forEach(item => {
            organize_ids += item + ",";
        })
        
        var url = 'StaffBlacklist/selectAlls';
        var record = {
          data_grouping: 'Hmdgl',
          organize_ids: organize_ids,
          city_id: this.condition.city_id,
          dictionaries_time: this.condition.start_date,
          staff_name: this.condition.staff_name,
          dictionaries_id: this.condition.dictionaries_id,
        };
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						if(data.length > 0){
							this.$message.success("导表成功！文件下载中！");
							return data;
						}else{
							this.$message.success("没有可以导出的数据！");
							return null;
						}
						
					} else {
						this.$message.warning(data);
					}
				}
			},
    
    //分页
    handleCurrentChange(val) {
      this.page_num = val;
      this.Find();
    },
    //清除数据
    trash() {
      this.ruleForm.id = '';
      this.ruleForm.template_name = '';
      this.ruleForm.dictionaries_name = '';
      this.ruleForm.template_date = '';
      this.ruleForm.template_content = '';
      this.ruleForm.template_url = '';
      this.ruleForm.template_state = '';
      this.ruleForm.reviewer_name = '';
      this.ruleForm.reviewer_date = '';
      this.ruleForm.reject_reason = '';
      this.ruleForm.dictionaries_name = '';
      this.ruleForm.start_date = '';
      this.ruleForm.end_date = '';
    },
		//初始化组织架构及下面的人
		async organizeFind() {
		    var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
		        identification: "1",
		    });
		    this.organizeList = this.getTreeData(organizeList.data);
		
		},
		getTreeData(data) {
		    // 循环遍历json数据
		    for (var i = 0; i < data.length; i++) {
		
		        if (data[i].organizeList.length < 1) {
		            // children若为空数组，则将children设为undefined
		            data[i].organizeList = undefined;
		        } else {
		            // children若不为空数组，则继续 递归调用 本方法
		            this.getTreeData(data[i].organizeList);
		        }
		    }
		    return data;
		}
  },
  async created() {
    this.Find();
    this.organizeFind();
    // 离职原因数据
			var causeList = await this.$globals.AxiosPost('dictionaries/selectFind', {
				data_grouping: 'resignation_reason'
			});
			this.causeList = causeList.data;
  },
};
</script>

<style>
.el-button--goon:focus,
.el-button--goon:hover {
  background: #006e4b;
  border-color: #05573d;
  color: #fff;
}
.el-button--addbtn:focus,
.el-button--addbtn:hover {
  background: #fff;
  border-color: #05573d;
  color: #006e4b;
}
.el-button--goon {
  color: #fff;
  background-color: #006e4b;
  border-color: #006e4b;
  font-size: 15px;
  width: 85px;
}
.el-button--addbtn {
  color: #006e4b;
  background-color: #fff;
  border-color: #006e4b;
  font-size: 15px;
  width: 85px;
}
.el-table .warning-row {
  background: oldlace;
}
.el-table .success-row {
  background: #f0f9eb;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #006e4b;
  border-color: #006e4b;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #006e4b;
}
.el-checkbox__inner:hover {
  border-color: #006e4b;
}
.el-button--pic {
  color: #006E4B;
  background-color: #fff;
  border-color:  #006E4B;
  font-size: 10px;
  height:30px;
  width: 70px;
  padding: 10px;
}
.el-button--pic:focus,
.el-button--pic:hover {
  background: #fff;
  border-color:  #05573d;
  color: #006E4B;
}
</style>


// WEBPACK FOOTER //
// Hmdgl.vue?38893e2c